export default __webpack_public_path__ + "39e18dc78dd10f805973c3085fc0a9cb.svg";